export function getRandomColor(index) {
  var colors = ["#fff", "#0042C61a"];
  var colorIndex = index % colors.length;

  var selectedColor = colors[colorIndex];

  return selectedColor;
}
